import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";

@Component({
  selector: "app-analytics-reviews",
  templateUrl: "./analytics-reviews.component.html",
  styleUrls: ["./analytics-reviews.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AnalyticsReviewsComponent implements OnInit {
  constructor() {}

  public pieChartLabels: string[];
  public pieChartData: number[];
  public pieChartType: string = "pie";
  public pieChartColors: Array<any> = [];

  // events
  public chartClicked(e: any): void {
    // console.log(e);
  }

  public chartHovered(e: any): void {
    // console.log(e);
  }

  ngOnInit() {
    this.pieChartColors = ["#868E96", "#03c0c2"];
    this.pieChartLabels = ["3rd Party", "Organic"];
    this.pieChartData = [3567, 2345];
    this.pieChartColors = [
      {
        // all colors in order
        backgroundColor: ["#868E96", "#03c0c2"],
      },
    ];
  }
}
